import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiChevronRight, FiHome } = FiIcons;

const Breadcrumbs = ({ items }) => {
  return (
    <nav className="flex text-sm text-slate-500 mb-6 font-medium" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        <li className="inline-flex items-center">
          <Link to="/" className="inline-flex items-center hover:text-sky-600 transition-colors">
            <SafeIcon icon={FiHome} className="w-4 h-4 mr-2" />
            Home
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={item.path || index}>
            <div className="flex items-center">
              <SafeIcon icon={FiChevronRight} className="w-4 h-4 text-slate-400 mx-1" />
              {item.path ? (
                <Link to={item.path} className="hover:text-sky-600 transition-colors ml-1 md:ml-2">
                  {item.label}
                </Link>
              ) : (
                <span className="text-slate-800 ml-1 md:ml-2">{item.label}</span>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;